//Extract code from this side
import LockIcon from "@mui/icons-material/Lock";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import api from "../../../../../../api/api";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { AssignmentType } from "../../../../../../utils/consts";
import QuestionNew from "../../../questions/Question_new";
import { CircularProgress, Grid, LinearProgress } from "@mui/material";
import StudentAssignmentScore from "./StudentAssignmentScore";
import dayjs from "dayjs";
import { black_assignment_icon, openbook2 ,book_animate} from "../../../../../../assets/images/images";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from "react-tooltip";
import PreprocessAndRenderLatex from "../../../../../../components/ProcessRenderLatex";
import { processLatex } from "../../../../../../utils/PreProcessorLatexCode";
import Lesson from "../../../../../../components/AddToCart/AddToCartLesson";
import "./LessonCard.css";
import { useSelector } from "react-redux";


const LessonCardCompetitive = ({ lesson, index, course, courseId, inial_value, lessons, isLocked = false }) => {
  
  const { token } = useAuth();
  const navigate = useNavigate();
    const globalState = useSelector((state) => state.globalState);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [showScorePopup, setshowScorePopup] = useState(false);
  const [detailedResult, setdetailedResult] = useState(false);
  const [assignment, setAssignment] = useState();
  const [assignments, setAssignments] = useState([]);
  const [assignmentCount, setAssignmentCount] = useState(0);
  const [assignmentCountLoading, setAssignmentCountLoading] = useState(true);
  const [assignmentIndex, setAssignmentIndex] = useState(0);
  // const [retryCount, setRetryCount] = useState(0);
  const [arrayIndex, setArrayIndex] = useState(0);
  const [openStudentViewDetails, setopenStudentViewDetails] = useState(false);
  const assignmentType = course?.course_type;
  const type = course?.type;
  const [previewDtls, setpreviewDtls] = useState([]);
  const [previewLessonIndex, setPreviewLessonIndex] = useState(index);
  const [previewLesson, setPreviewLesson] = useState(lesson);
  const isCourseActive =
  course?.status === "Active" || course?.status === "Completed";
  const isMarketplace = globalState?.enabled_modules?.includes('marketplace');




  const toggleDropdown2 = () => {
    setShowDropdown2(!showDropdown2); // Toggle the visibility state
  };


  function fetchAssignments(retryAttempt = 0) {
    setAssignmentCountLoading(true);

  const endpoint = `/competitive/assignments/get-assignments-by-lesson/${lesson.lesson_id}/`;


    // Create a timeout promise
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Request timeout')), 10000); // 10 second timeout
    });

    // Race between API call and timeout
    Promise.race([
      api.get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }),
      timeoutPromise
    ])
      .then((response) => {
        if (response.status === 200) {
          const newCount = response?.data?.count || 0;
          setAssignments(response?.data?.data || []);
          setAssignmentCount(newCount);
          setAssignmentCountLoading(false);
          // setRetryCount(0); // Reset retry count on success
          checkSubmissions(response?.data?.data || []);
        }
      })
      .catch((error) => {
        console.error('Assignment fetch error:', error);

        // Retry logic - retry up to 2 times with exponential backoff
        if (retryAttempt < 2) {
          const delay = Math.pow(2, retryAttempt) * 1000; // 1s, 2s delays
          setTimeout(() => {
            // setRetryCount(retryAttempt + 1);
            fetchAssignments(retryAttempt + 1);
          }, delay);
        } else {
          // Final fallback - set to 0
          setAssignmentCount(0);
          setAssignments([]);
          setAssignmentCountLoading(false);
          // setRetryCount(0);
        }
      });
  }



  useEffect(() => {
    fetchAssignments()
  }, [lesson.lesson_id, token]);

  useEffect(() => {
    const lsn = lessons?.[previewLessonIndex];
    if (!lsn) return;

    setPreviewLesson(lsn);
    setpreviewDtls(lsn?.ai_overview || []);
  }, [previewLessonIndex, lessons]);

  function checkSubmissions(assignments) {
    const anyNullSubmissions = assignments.some(assignment => assignment?.assignment_status?.status == 'Submission-Progress');
    if (anyNullSubmissions) {
      setTimeout(fetchAssignments, 15000);
    }
  }


  const getAssignmentTypeName = (type) => {
    return Object.values(AssignmentType).find((item) => {
      return item.value === type;
    })?.name;
  };

  const onLesssonClick = (lesson) => {
    if (lesson.lesson_status !== "Completed") {
      const formData = new FormData();
      formData.append("status", 2);
      formData.append("lesson_id", lesson?.lesson_id);
      const url = "lessons/update-lesson-status/";
      const headers = {
        Authorization: `Token ${token}`,
      };
      api
        .post(url, formData, { headers })
        .then((response) => {
          if (response.data.status === 200) {
            // Update status if necessary
          }
        })
        .catch((error) => {
          // Handle error
        });
    }

    const course_Id = courseId == '' || courseId == undefined ? course?.course_id : courseId;
    navigate(`/course/${course_Id}/lesson/${lesson?.lesson_id}/overview`, {
      state: {
        course,
        lesson,
      },
    });
  };

  const showScore = (assgn, array) => {
    setAssignment(assgn);
    setAssignmentIndex(0);
    setArrayIndex(array);
    setdetailedResult(!detailedResult);

  };

  const showDetailedResult = () => {
    setAssignmentIndex(0);
    setdetailedResult(!detailedResult);
    setshowScorePopup(false);
  };

  // const getAssignmentCount = (assignment, index) => {
  //   return <h5>{`Assignment: ${index + 1}`}</h5>
  // }
  // const renderAssignmentButton = (assignment, index) => {
  //   return assignment?.submission != null ? (
  //     <>
  //       <div key={index} className="StudentViewCourseDetails-lesson-inner-assignments-folder">
  //         <button
  //           onClick={() =>
  //             showScore(assignment, assignment?.submission?.student_answers_json)
  //           }
  //           type="button"
  //           className="StudentViewCourseDetails_view_Score"
  //         >
  //           View Result
  //         </button>
  //       </div>
  //     </>
  //   ) : (assignment?.assignment_status?.status && assignment?.assignment_status?.status == 'Submission-Progress' ? (
  //     <>
  //       <div key={index} className="StudentViewCourseDetails-lesson-inner-assignments-folder">
  //         <button
  //           disabled={true}
  //           type="button"
  //           className="StudentViewCourseDetails_view_Score_progress result-in-progress"
  //         >
  //           Grading in progress ...
  //           <CircularProgress size={15} className="circular-progress" />
  //         </button>
  //       </div>
  //     </>

  //   ) : null);
  // };

  const currentDate = dayjs(); // Get current date
  const courseStartDate = dayjs(course?.start_date);
  const courseEndDate = course?.end_date ? dayjs(course?.end_date) : null;
  // const isButtonDisabled = currentDate.isBefore(courseStartDate) || (courseEndDate && currentDate.isAfter(courseEndDate));

  // // Get the current date and compare with the lesson start date
  // // const currentDate = dayjs(); // Get current date
  const lessonStartDate = dayjs(lesson?.start_date);  // Parse the lesson's start date
  const lessonEndDate = lesson?.end_date ? dayjs(lesson?.end_date) : null;  // Parse the lesson's end date if available
  const isLessonAvailable = !currentDate.isBefore(lessonStartDate) && !(lessonEndDate && currentDate.isAfter(lessonEndDate));

  // If the lesson is not available (start date is in the future), return null to hide the whole component
  if (!isLessonAvailable) {
    return null;
  }

  // const isPrevLessonSubmitted = index > 0 ? lessons[index - 1]?.comp_assignment_submission : true;
  // console.log("isPrevLessonSubmitted",isPrevLessonSubmitted);



  const ShowStudentViewDetails = () => {    
    setopenStudentViewDetails(true);
    setPreviewLessonIndex(index);          // start preview at the current card
    setPreviewLesson(lesson);
    setpreviewDtls(lesson?.ai_overview || []);
  }

  const goToNext = () => {
    setPreviewLessonIndex((prev) => {
      const next = prev + 1; 
      if (!lessons?.[next]) return prev;   // stop at last
      return next;
    });
      document.querySelector('.Course-created-successfully-folder')?.scrollTo({ top: 0, behavior: 'smooth' });

  };

  const goToPrev = () => {
    setPreviewLessonIndex((prev) => {
      const back = prev - 1;
      if (back < 0) return prev;           // stop at first
      return back;
    });
      document.querySelector('.Course-created-successfully-folder')?.scrollTo({ top: 0, behavior: 'smooth' });

  };


  return isCourseActive? (
    <>
      <div className="Student-strat-lesson-main-folder">
        <div className="Student-Active-main-wrapper shadow-none !p-2 !mx-0 !my-2 md:!m-2">
          <div key={index} className="Student-Active-Lesson-folder tab-view flex flex-row items-center gap-4 md:gap-[45px]">
            <div
              className="Student-Active-Lesson-title-folder lesson-dropdown-tab"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown2();
              }}
            >
              <i
                className={`fa-solid ${showDropdown2 ? "fa-angle-down" : "fa-angle-right"
                  }`}
              ></i>
                <h2>
                  {inial_value + index > 8
                    ? "Part " + (inial_value + index + 1)
                    : "Part 0" + (inial_value + index + 1)}
                </h2>
            </div>
            {/* <p className="Student-Active-Lesson-des"     data-tooltip-id="lesson-tooltip" data-tooltip-content={lesson?.name}>  {lesson?.name?.length > 30
    ? lesson.name.slice(0, 30) + "..."
    : lesson?.name}</p> */}
                <span className="lc-lesson-name w-max md:!truncate md:w-[10rem] text-[0.85rem] font-medium"  data-tooltip-id="lesson-tooltip" data-tooltip-content={lesson?.name}>  {lesson?.name}</span>
            <div className="Student-progressBar-container">
              <div className="Student-Active-assignment-progress w-full md:w-auto">
                <LinearProgress variant="determinate" value={lesson?.assignment_progress_percentage ?? 0} sx={{
                  height: 10,
                  backgroundColor: "#eee",
                  borderRadius: 50, // makes outer track rounded assignment_progress_percentage

                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#1976d2",
                    borderRadius: 50, // makes outer track rounded

                  }
                }} />
              </div>
              <div>{lesson?.assignment_progress_percentage  ?? 0}%</div>
            </div>


            <div className="view-result-assignment-progress-folder !w-max">
              {/* <h5>{`Assignment: ${assignments.length}`}</h5> */}
              <img src={black_assignment_icon} />
              {/* <h5>{`Assignment: ${assignmentCount}`}</h5> */}
                <h5>{`Assignment: 1`}</h5>
            </div>
            {/* {isMarketplace &&
            <button className="View-details-btn" onClick={(e) => ShowStudentViewDetails()}>View Details</button>} */}
            {lesson.is_skip ? (<button
              disabled={course?.status === "Pending" || course?.status === "" || course?.status === null || assignmentCount === 0 || isLocked}
              // disabled={isButtonDisabled || course?.status === "Pending"}
              style={{
                cursor: (assignmentCount === 0 || isLocked) ? "not-allowed" : "pointer",
                backgroundColor: (assignmentCount === 0 || isLocked) ? "#B3B3B3" : "",  // light gray background
                borderColor: (assignmentCount === 0 || isLocked) ? "#a0a0a0" : "",
              }}
              onClick={() => onLesssonClick(lesson)}
              className="Student-Active-start-Lesson !w-[130px] !py-[7px] !px-[25px] !ml-0 md:!w-[100px]"
              {...((assignmentCount === 0 ) ? {
                "data-tooltip-id": "chatbot-data-workboard",
                "data-tooltip-content": "Please complete the above lesson to access this lesson"
              } : {})}
            >
              {(course?.status === "Pending" || course?.status === "" || course?.status === null) && <LockIcon />}{" "}
              { "View"}

              {/* Assignment                                                */}
            </button>
            ) : (
              <button
                disabled={course?.status === "Pending" || course?.status === "" || course?.status === null || assignmentCount === 0 || isLocked }
                // disabled={isButtonDisabled || course?.status === "Pending"}
                style={{
                  cursor: (assignmentCount === 0 || isLocked) ? "not-allowed" : "pointer",
                  backgroundColor: (assignmentCount === 0 || isLocked) ? "#B3B3B3" : "",  // light gray background
                  borderColor: (assignmentCount === 0 || isLocked) ? "#a0a0a0" : "",
                }}
                onClick={() => onLesssonClick(lesson)}
                className="Student-Active-start-Lesson !w-[130px] !py-[7px] !px-[25px] !ml-0 md:!w-[100px]"
                {...((assignmentCount === 0) ? {
                  "data-tooltip-id": "chatbot-data-workboard",
                  "data-tooltip-content": "Please complete the above lesson to access this lesson"
                } : {})}
              >
                {(course?.status === "Pending" || course?.status === "" || course?.status === null) && <LockIcon />}{" "}
                {"View"}

                {/* Lesson */}
              </button>
            )
            }
          </div>
          <Tooltip
            id="chatbot-data-workboard"
            place="top"
            // content="Show/Hide chatbot during assignments"
            type="light"
            effect="float"
          />
            <Tooltip
              id="lesson-tooltip" place="top" 
          />
          {showDropdown2 && (
            <div className="StudentViewCourseDetails-lesson-inner-assignments-container !border-t !border-t-[#D9D9D9] !border-x-0 !border-b-0 !mt-0 md:!mt-4 !pt-4 !px-0 !pb-0 !rounded-none">
              {/* <h2>{lesson?.name}</h2> */}
              <h4 className="font-medium">Assignments</h4>
              <div className="StudentViewCourseDetails-lesson-inner-assignments-wrapper !mt-2 md:!mt-4">
                {assignments?.map((assignment, i, array) => (
                  <div
                    key={i}
                    className="StudentViewCourseDetails-lesson-inner-assignments-folder flex flex-row !items-center justify-between"
                  >
                    <div className="StudentViewCourseDetails-inner-assignments-text-feild">
                      <h2 style={{ color: "#555555", fontWeight: 500 }} className="pb-0">
                        Assignment: <span>{i + 1}</span>:{" "}
                        <span>{assignment?.name}</span>
                      </h2>
                      <p style={{ color: "#555555" }}>{getAssignmentTypeName(assignment?.type)}</p>
                    </div>
                    {/* {assignment?.submission != null && ( */}
                      <button
                        onClick={() => showScore(assignment, assignment?.submission?.student_answers_json)}
                        type="button"
                        className="StudentViewCourseDetails_view_Score border-none underline !text-[12px] md:!text-[14px] focus:outline-none focus:border-none"
                        style={ assignment?.submission != null  ? { color: "#0FBA00",  }: {  color: "#B3B3B3", }}
                        disabled={assignment?.submission == null}
                      >
                        View Result
                      </button>
                    {/* )} */}
                  </div>
                ))}
              </div>
            </div>
          )}

          {showScorePopup && (
            <StudentAssignmentScore
              view={"lesson"}
              showScore={showScore}
              getSubmissiondtls={assignment?.submission?.ai_evaluation_json}
              onclick={showDetailedResult}
              title={"View Detailed Result"}
              submission_Id={assignment?.submission?.submission_id}
            />
          )}
          {detailedResult && (
            <div className="AssignmentViewProgress-mock-test-wrapper">
              <div className="AssignmentViewProgress-mock-test-container max-h-[90vh] overflow-y-auto">
                {
                  <QuestionNew
                    assignment={
                      assignment?.submission?.student_answers_json[
                      assignmentIndex
                      ]
                    }
                    ai_evaluation_json={
                      assignment?.submission?.ai_evaluation_json
                    }
                    index={assignmentIndex}
                    arrayIndex={arrayIndex}
                    currentStep={assignmentIndex + 1}
                    totalSteps={
                      assignment?.submission?.student_answers_json.length
                    }
                    handleNext={() =>
                      assignmentIndex <
                        assignment?.submission?.student_answers_json.length - 1
                        ? setAssignmentIndex((p) => p + 1)
                        : null
                    }
                    handleBack={() => setAssignmentIndex((p) => p - 1)}
                    isLast={
                      assignmentIndex ===
                      assignment?.submission?.student_answers_json.length - 1
                    }
                    isFirst={assignmentIndex === 0}
                    close={
                      <span
                        onClick={showDetailedResult}
                        className="AssignmentViewProgress-mock-test-close-btn"
                      >
                        <i className="fa-solid fa-x"></i>
                      </span>
                    }
                    questions={assignment?.submission?.ai_evaluation_json?.questions}
                    courseType={assignmentType}
                  />
                }
              </div>
            </div>
          )}
          {openStudentViewDetails && (
            <div className="preview-student-wrapperB">
              <div
                // style={{ padding: "30px 20px" }}
                className="Course-created-successfully-container-viewDetailsB"
              >
                <div className="view-details-header-folder" >
                  <div className="view-details-header-lessonNumber">
                    <h4>
                      {inial_value + previewLessonIndex > 8
                        ? "Lesson  " + (inial_value + previewLessonIndex + 1) + ":"
                        : "Lesson 0" + (inial_value + previewLessonIndex + 1) + ":"}
                    </h4>
                  </div>
                  <div className="view-details-header-lessonName">
                    <h4 >
                      {previewLesson?.name}
                    </h4>
                  </div>
                </div>
                {/* dismiss modal */}
                <div
                  className="close-modal-btn-student-viewB"
                  onClick={() => setopenStudentViewDetails(false)}
                >
                  <a>
                    <i className="fa-solid fa-xmark dismis-close"></i>
                  </a>
                </div>

                <div
                  style={{ height: "482px", zIndex: 999, overflow: "auto" }}
                  className="Course-created-successfully-folder"
                >

                  {
                    previewDtls && previewDtls.length > 0 ? (
                      previewDtls.map((dtls, index) => (
                        <div key={index} style={{ marginBottom: "20px", alignItems: "flex-start", }}>
                          <h1>{dtls.section_header}</h1>
                          <div style={{ alignItems: "flex-start" }}>
                            <PreprocessAndRenderLatex
                              content={dtls.section_description}
                              isBlockMath={false}
                            />
                          </div>

                        </div>
                      ))
                    ) : (
                    // <p>No details available for this lesson.</p>
                    <div className="no-lesson-created-to-proceed-assignment">     
                                    {/* <img src={openbook2} alt="openbook"></img> */}
 <h3>Your teacher is preparing something great!</h3>
                              <img style={{ width: "252px" }} src={book_animate} alt="book_animate" />
                              <h3>This lesson will be ready soon!</h3>
                                    {/* fixed */}

                                    {/* <span className="Students-courses-details-folder span">Let's move forward to your assignment</span> */}

                                  </div>
                  )
                  }
                </div>
                <div className="Course-created-successfully-container-viewDetails-footer">
                  <span
                    onClick={goToPrev}
                    style={{ cursor: previewLessonIndex === 0 ? "not-allowed" : "pointer", opacity: previewLessonIndex === 0 ? 0.5 : 1 }}
                  ><i className="fa-solid fa-chevron-left"></i> Back
                  </span>
                  <span
                    onClick={goToNext}
                    style={{ color: "#0068ff", cursor: previewLessonIndex === lessons.length - 1 ? "not-allowed" : "pointer", opacity: previewLessonIndex === lessons.length - 1 ? 0.5 : 1 }}
                  >Next Lesson <i className="fa-solid fa-chevron-right"></i></span>
                </div>

              </div>
            </div>
          )}
        </div>
      </div>
    </>
  ):(
    <>
<div className="Student-strat-lesson-main-folder lc-disabled-wrapper">
  <div className="Student-Active-main-wrapper shadow-none !p-2 !mx-0 !my-2 md:!m-2">
    <div className="Student-Active-Lesson-folder tab-view flex flex-row items-center gap-4 md:gap-[45px] lc-disabled-card">

      <div className="Student-Active-Lesson-title-folder lesson-dropdown-tab lc-disabled-title">
        <i className="fa-solid fa-angle-right lc-disabled-icon"></i>
          <h2 className="lc-disabled-heading">
            {inial_value + index > 8
              ? "Part " + (inial_value + index + 1)
              : "Part 0" + (inial_value + index + 1)}
          </h2>
      </div>

      {/* <p className="lc-lesson-name"  style={{width:"180px" , fontSize:"15px", fontWeight:"500"}}   data-tooltip-id="lesson-tooltip" data-tooltip-content={lesson?.name}>
        {lesson?.name?.length > 20
          ? lesson.name.slice(0, 20) + "..."
          : lesson?.name}
      </p> */}
      <span className="lc-lesson-name w-max md:!truncate md:w-[10rem] text-[0.85rem] font-medium"   data-tooltip-id="lesson-tooltip" data-tooltip-content={lesson?.name}>
        {lesson?.name}
      </span>

      <div className="Student-progressBar-container lc-disabled-progress-container">
        <div className="Student-Active-assignment-progress lc-disabled-progress-bar w-full md:w-auto">
          <LinearProgress
            variant="determinate"
            value={0}
            sx={{
              height: 10,
              backgroundColor: "#e0e0e0",
              borderRadius: 50,
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#b0b0b0",
                borderRadius: 50,
              },
            }}
          />
        </div>
        <div className="lc-disabled-percent">0%</div>
      </div>

      <div className="view-result-assignment-progress-folder lc-disabled-assignment-row w-max">
        <img src={black_assignment_icon} className="lc-disabled-assignment-icon" />
        <h5 className="lc-disabled-assignment-text">
          {assignmentType === 1
            ? `Assignment:${assignmentCount}`
            : `Assignment:1`}
        </h5>
      </div>
{/* {isMarketplace &&
      <button className="View-details-btn" onClick={(e) => ShowStudentViewDetails()}>View Details</button>} */}

      <button className="Student-Active-start-Lesson lc-disabled-start-btn !w-[130px] !py-[7px] !px-[25px] !ml-0 md:!w-[100px] " disabled>
        <LockIcon className="lc-lock-icon" />
        Start
      </button>
    </div>

              <Tooltip
            id="chatbot-data-workboard"
            place="top"
            // content="Show/Hide chatbot during assignments"
            type="light"
            effect="float"
          />
            <Tooltip
              id="lesson-tooltip" place="top" 
          />
              {openStudentViewDetails && (
            <div className="preview-student-wrapperB">
              <div
                // style={{ padding: "30px 20px" }}
                className="Course-created-successfully-container-viewDetailsB"
              >
                <div className="view-details-header-folder" >
                  <div className="view-details-header-lessonNumber">
                    <h4>
                      {inial_value + previewLessonIndex > 8
                        ? "Lesson  " + (inial_value + previewLessonIndex + 1) + ":"
                        : "Lesson 0" + (inial_value + previewLessonIndex + 1) + ":"}
                    </h4>
                  </div>
                  <div className="view-details-header-lessonName">
                    <h4 >
                      {previewLesson?.name}
                    </h4>
                  </div>
                </div>
                {/* dismiss modal */}
                <div
                  className="close-modal-btn-student-viewB"
                  onClick={() => setopenStudentViewDetails(false)}
                >
                  <a>
                    <i className="fa-solid fa-xmark dismis-close"></i>
                  </a>
                </div>

                <div
                  style={{ height: "482px", zIndex: 999, overflow: "auto" }}
                  className="Course-created-successfully-folder"
                >

                  {
                    previewDtls && previewDtls.length > 0 ? (
                      previewDtls.map((dtls, index) => (
                        <div key={index} style={{ marginBottom: "20px", alignItems: "flex-start", }}>
                          <h1>{dtls.section_header}</h1>
                          <div style={{ alignItems: "flex-start" }}>
                            <PreprocessAndRenderLatex
                              content={dtls.section_description}
                              isBlockMath={false}
                            />
                          </div>

                        </div>
                      ))
                    ) : (
                    //<p>No details available for this l.</p>
                      <div className="no-lesson-created-to-proceed-assignment">     
                                    {/* <img src={openbook2} alt="openbook"></img> */}
 <h3>Your teacher is preparing something great!</h3>
                              <img style={{ width: "252px" }} src={book_animate} alt="book_animate" />
                              <h3>This lesson will be ready soon!</h3>
                                    {/* fixed */}

                                    {/* <span className="Students-courses-details-folder span">Let's move forward to your assignment</span> */}

                                  </div>
                  )
                  }
                </div>
                <div className="Course-created-successfully-container-viewDetails-footer">
                  <span
                    onClick={goToPrev}
                    style={{ cursor: previewLessonIndex === 0 ? "not-allowed" : "pointer", opacity: previewLessonIndex === 0 ? 0.5 : 1 }}
                  ><i className="fa-solid fa-chevron-left"></i> Back
                  </span>
                  <span
                    onClick={goToNext}
                    style={{ color: "#0068ff", cursor: previewLessonIndex === lessons.length - 1 ? "not-allowed" : "pointer", opacity: previewLessonIndex === lessons.length - 1 ? 0.5 : 1 }}
                  >Next Lesson <i className="fa-solid fa-chevron-right"></i></span>
                </div>

              </div>
            </div>
          )}
  </div>
</div>
    </>
  )
};

export default LessonCardCompetitive;